import { render, staticRenderFns } from "./DanhSachCanBoThemVaoNguoiDung.vue?vue&type=template&id=b66be370&"
import script from "./DanhSachCanBoThemVaoNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachCanBoThemVaoNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports